var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AlertComponent',{attrs:{"alert":this.alert}}),_vm._v(" "),(this.render)?_c('editarPerfil',{attrs:{"alert":this.alert,"cadastro":true,"conta":this.usuario}}):_vm._e(),_vm._v(" "),(this.loading)?_c('v-icon',{staticClass:"custom-loader"},[_vm._v("cached")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc344136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guestArea/novoUsuario/NovoUsuario.vue
// module id = 872
// module chunks = 0